import { render, staticRenderFns } from "./PreviewLatest.vue?vue&type=template&id=65c0881f&scoped=true"
import script from "./PreviewLatest.vue?vue&type=script&lang=js"
export * from "./PreviewLatest.vue?vue&type=script&lang=js"
import style0 from "./PreviewLatest.vue?vue&type=style&index=0&id=65c0881f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0881f",
  null
  
)

export default component.exports